import script from "./user-side-bar-menu-list.vue?vue&type=script&setup=true&lang=js"
export * from "./user-side-bar-menu-list.vue?vue&type=script&setup=true&lang=js"

import "./user-side-bar-menu-list.vue?vue&type=style&index=0&id=368e0a0a&lang=css"

const __exports__ = script;

export default __exports__